"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _pickAttrs = _interopRequireDefault(require("rc-util/lib/pickAttrs"));
var _Input = _interopRequireDefault(require("./Input"));
var _StyledSelect = require("../../StyledSelect");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var SingleSelector = function SingleSelector(props) {
  var theme = props.theme,
    inputElement = props.inputElement,
    prefixCls = props.prefixCls,
    id = props.id,
    inputRef = props.inputRef,
    disabled = props.disabled,
    autoFocus = props.autoFocus,
    autoComplete = props.autoComplete,
    accessibilityIndex = props.accessibilityIndex,
    mode = props.mode,
    open = props.open,
    values = props.values,
    placeholder = props.placeholder,
    tabIndex = props.tabIndex,
    showSearch = props.showSearch,
    searchValue = props.searchValue,
    activeValue = props.activeValue,
    maxLength = props.maxLength,
    upperCase = props.upperCase,
    onInputKeyDown = props.onInputKeyDown,
    onInputMouseDown = props.onInputMouseDown,
    onInputChange = props.onInputChange,
    onInputPaste = props.onInputPaste,
    onInputCompositionStart = props.onInputCompositionStart,
    onInputCompositionEnd = props.onInputCompositionEnd;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    inputChanged = _useState2[0],
    setInputChanged = _useState2[1];
  var combobox = mode === 'combobox';
  var inputEditable = combobox || showSearch;
  var item = values[0];
  var inputValue = searchValue || '';
  if (combobox && activeValue && !inputChanged) {
    inputValue = activeValue;
  }
  (0, _react.useEffect)(function () {
    if (combobox) {
      setInputChanged(false);
    }
  }, [combobox, activeValue]);

  // Not show text when closed expect combobox mode
  var hasTextInput = mode !== 'combobox' && !open ? false : !!inputValue;
  var title = item && (typeof item.label === 'string' || typeof item.label === 'number') ? item.label.toString() : '';
  function handleDisplayMouseEnter(e) {
    if (e.target && e.target.scrollWidth > e.target.offsetWidth) {
      e.target.setAttribute('title', title);
    }
  }
  function handleDisplayMouseLeave(e) {
    e.target.setAttribute('title', '');
  }
  return /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledSelectionRendered, {
    theme: theme,
    $single: true
  }, /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledSearchInline, {
    theme: theme,
    className: "".concat(prefixCls, "-selection-search")
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    theme: theme,
    ref: inputRef,
    prefixCls: prefixCls,
    id: id,
    open: open,
    inputElement: inputElement,
    disabled: disabled,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    editable: inputEditable,
    accessibilityIndex: accessibilityIndex,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: function onChange(e) {
      setInputChanged(true);
      onInputChange(e);
    },
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    tabIndex: tabIndex,
    attrs: (0, _pickAttrs.default)(props, true),
    maxLength: combobox ? maxLength : undefined,
    upperCase: upperCase
  })), !combobox && item && !hasTextInput && /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledSelectionSelectedValue, {
    theme: theme,
    key: "value",
    $open: open,
    $showSearch: showSearch,
    className: "".concat(prefixCls, "-selection-item"),
    onMouseEnter: handleDisplayMouseEnter,
    onMouseLeave: handleDisplayMouseLeave
  }, item.label), !item && !hasTextInput && /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledSelectionPlaceholder, {
    theme: theme,
    className: "".concat(prefixCls, "-selection-placeholder")
  }, placeholder));
};
var _default = exports.default = SingleSelector;